import { ApiResult, HttpClient } from "../http.js";
import { DashboardSummaryDto } from "../types/dashboard.js";

export class DashboardApi {
  constructor(private readonly http: HttpClient) {}

  summary(): Promise<ApiResult<DashboardSummaryDto>> {
    return this.http.get<DashboardSummaryDto>("/api/dashboard/summary");
  }
}
